import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { isValidationError } from 'src/app/errors/error-helper';

import { environment } from '../../../../environments/environment';
import { AuthError } from '../errors/auth-error';
import { AccountDTO } from '../interfaces/account.dto';
import { User } from '../models/user.model';
import { UserInfo } from '../models/user-info.model';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private httpClient = inject(HttpClient);
  private apiHost = environment.authApi;

  login(
    username: string,
    password: string,
    rememberMe: boolean
  ): Observable<User> {
    const authError = new AuthError(
      'Korisnik ne postoji ili ste unijeli pogrešnu lozinku!'
    );

    return this.httpClient
      .post<AccountDTO>(this.apiHost + '/signin', {
        username,
        password,
        rememberMe,
      })
      .pipe(
        map((response) => {
          if (!response) {
            throw authError;
          }
          localStorage.setItem('account', JSON.stringify(response));
          return new User().loadModel(response.user);
        }),
        catchError((error) => {
          if (isValidationError(error)) {
            return throwError(() => authError);
          }

          return throwError(() => error);
        })
      );
  }

  logout() {
    localStorage.removeItem('account');
    location.reload();
  }

  getUserInfo() {
    const account = this.getAccount();
    if (!account) {
      return new UserInfo();
    }
    return new UserInfo().loadModel(account.user.user_info);
  }

  getUser() {
    const account = this.getAccount();
    if (!account) {
      return new User();
    }
    return new User().loadModel(account.user);
  }

  getAccount() {
    const accountFromLocalStorage = localStorage.getItem('account');
    if (!accountFromLocalStorage) {
      return null;
    }
    const account: AccountDTO = JSON.parse(accountFromLocalStorage);
    return account;
  }

  isLoggedIn() {
    const user = localStorage.getItem('account');
    const loggedIn = !!user;

    return loggedIn;
  }

  getUserToken() {
    const user = localStorage.getItem('account');
    if (!user) {
      return;
    }
    return JSON.parse(user).accessToken;
  }

  resetPassword(token: string, password: string) {
    return this.httpClient.post(this.apiHost + '/reset-password', {
      token,
      password,
    });
  }

  sendPasswordResetToken(email: string) {
    return this.httpClient.post(
      this.apiHost + '/auth/send-password-reset-token',
      {
        username: email,
      }
    );
  }

  validateToken(token: string) {
    return this.httpClient.post(this.apiHost + '/auth/verify-token', {
      token: token,
    });
  }

  validateResetToken(token: string) {
    return this.httpClient.post(
      this.apiHost + '/auth/verify-password-reset-token',
      {
        token: token,
      }
    );
  }
}
